<template>
  <div>
    <div v-if="video" class="container bg-white ">
      <div>
        <div class="d-flex fd-column">
          <div>
            <div class="TITLE">Pro Education</div>
            <div class="d-flex fd-column fd-column-reverse:mo">
              <div v-show="quizError" class="ERROR m-b-1 m-l-3 m-l-1:mo">
                Sorry, you didn’t answer correctly.
                Please watch the video again to access the quiz.</div>
              <a class="BLUE d-flex m-l-3 m-l-1:mo" @click="back">
                <vk-icon
                    name="chevronleft"
                    size="15"
                    class="m-r-1 m-b-4 ARROW"
                    unbounded/>
                Back
              </a>
            </div>
          </div>
          <div>
            <div class="p-x-3:d p-b-2">
              <div ref="video-wrapper" class="VIDEO-WRAPPER">
                <div class="OVERLAY" v-if="videoWatched" >
                  <img class="IMG" :width="width" :height="width/1.77" :src="thumbnail" />
                  <div class="CONTROLS" >
                    <div class="CIRCLE cur-pointer" @click.prevent="refresh()">
                      <vk-icon
                          name="refresh"
                          :size="size"
                          class="REFRESH c-white"
                          unbounded/>
                    </div>
                    <button
                        v-if="showButton"
                        @click="gotoQuiz"
                        class="btn-sm btn">
                      Open Quiz
                    </button>
                  </div>
                </div>
                <div v-show="!videoWatched">
                  <div id="player"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="p-l-3:d d-flex fd-column">
            <green-bubble
                v-if="showQuizCompleted"
                bubbleText="Quiz completed"
                class="m-b-1"/>
            <div class="d-flex jc-between fd-column:mo">
              <div class="p-b-1 text-bold">{{ videoTitle }}</div>
              <div v-if="showThumbs">
                <div v-if="rated" class="d-flex p-b-1 m-r-2 ">
                  <div>Thank you for your feedback. This will help us to improve.</div>
                </div>
                <div v-else class="d-flex p-b-1 jc-between:mo">
                  <div>What did you think of the video?</div>
                  <div class="d-flex ai-start m-r-2">
                    <button
                        @click="rateVideo('up')"
                        class="ICON-BUTTON">
                      <img src="./assets/Like.svg">
                    </button>
                    <button
                        @click="rateVideo('down')"
                        class="ICON-BUTTON">
                      <img src="./assets/Dislike.svg">
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="p-b-1">{{ videoDescription }}</div>
            <div class="text-sm">{{ created }}</div>
          </div>
        </div>
      </div>
    </div>
    <vk-modal v-if ="showModal">
      <div class="bg-white MODAL m-3:mo">

        <vk-modal-content class="d-flex m-t-2">
          <div>
            <vk-icon
                name="exclamation-circle-outlined"
                size="24"
                class="m-x-2 INFO"
                unbounded/>
          </div>
          <div class="d-flex fd-column">
            <span class="text-bold m-b-1">The quiz has not been completed!</span>
            <span class="m-b-3 p-r-2 ">
              If you leave now, you won't earn credit towards rewards.
            </span>
            <div class="d-flex jc-end">

              <button class="btn-sm btn-secondary m-r-2" @click="skipQuiz">Leave</button>
              <button class="btn-sm btn" @click="gotoQuiz('modal')">Answer Quiz</button>
            </div>
          </div>
        </vk-modal-content>
      </div>
    </vk-modal>
  </div>
</template>

<script>
import { formatDistanceToNow } from 'date-fns';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import GreenBubble from '@/views/Dashboard/components/GreenBubble';


export default {
  name: 'video-watch',
  components: {
    GreenBubble,
  },
  data () {
    return {
      player: null,
      videoWatched: false,
      video: null,
      showQuiz: false,
      showButton: false,
      error: false,
      showSuccess: false,
      showModal: false,
      to: null,
      rated: false,
    };
  },
  computed: {
    ...mapGetters('account/pro/education', [
      'videoList',
      'quizError',
    ]),
    ...mapGetters('account/pro/info', [
      'serviceProviderId',
    ]),
    size () {
      return this.$device.isMobile ? 20 : 32;
    },
    thumbnail () {
      return `https://img.youtube.com/vi/${this.video.youtubeId}/maxresdefault.jpg`;
    },
    hasList () {
      return Object.keys(this.videoList).length && !!this.videoList;
    },
    width () {
      return this.video ? this.$refs['video-wrapper'].offsetWidth : 0;
    },
    height () {
      return this.width / 1.77;
    },
    id () {
      return this.video.youtubeId;
    },
    videoDescription () {
      return this.video.videoDescription;
    },
    created () {
      return `Created ${formatDistanceToNow(new Date(this.video.createdDate))} ago`;
    },
    videoTitle () {
      return this.video.videoTitle;
    },
    hasPassed () {
      return this.video.current_status === 'passed';
    },
    hasQuiz () {
      return !!this.video.quiz;
    },
    showQuizCompleted () {
      return this.videoWatched && this.hasPassed && this.hasQuiz;
    },
    showThumbs () {
      return this.videoWatched && !this.hasPassed;
    },
    videoId () {
      return this.$route.params.videoId;
    },
  },
  watch: {
    videoList: {
      immediate: true,
      handler (newVal, oldVal) {
        if (newVal !== oldVal) {
          this.video = this.videoList[this.videoId];
        }
      },
    },
    serviceProviderId: {
      immediate: true,
      handler (newVal) {
        if (newVal) {
          this.getVideoList();
        }
      },
    },
    video: {
      immediate: true,
      handler (newVal, oldVal) {
        if (newVal !== oldVal) {
          this.setVideo(newVal);
        }
      },
    },
  },
  beforeRouteLeave (to, from, next) {
    if (this.hasPassed || !this.video.quiz || to.name === 'dashboard::pro::quiz') {
      this.updateError(false);
      next();
      return;
    }
    if (this.to) {
      next();
      return;
    }
    this.showModal = true;
    this.to = to;
    next(false);
  },
  mounted () {
    if (this.video) {
      if (window.YT) {
        this.openPlayer();
      } else {
        this.loadYouTubeAPI();
      }
    }
  },
  methods: {
    ...mapActions('account/pro/education', ['fetchVideos', 'createRecord', 'updateError']),
    ...mapMutations('account/pro/education', ['setVideo']),
    async getVideoList () {
      if (Object.keys(this.videoList) < 1) {
        await this.fetchVideos({ serviceProviderId: this.serviceProviderId });
      }
      this.video = this.videoList[this.videoId];
      if (window.YT) {
        this.openPlayer();
      } else {
        this.loadYouTubeAPI();
      }
    },
    back () {
      this.$router.replace({ name: 'dashboard::pro::education' });
    },
    loadYouTubeAPI () {
      const tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      const firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

      window.onYouTubeIframeAPIReady = this.openPlayer;
    },
    onPlayerStateChange (event) {
      // This function is called when the player's state changes
      if (event.data === window.YT.PlayerState.ENDED) {
        this.videoWatched = true;
        if (!this.hasPassed) {
          if (this.video.quiz) {
            this.createRecord({ serviceProviderId: this.serviceProviderId, videoId: this.video.videoId, status: 'inprogress' });

            this.showButton = true;
          } else {
            this.createRecord({ serviceProviderId: this.serviceProviderId, videoId: this.video.videoId, status: 'passed' });
          }
        }
      }
    },
    onPlayerReady (event) {
      event.target.playbackRate = 1;
      event.target.playVideo();
    },
    openPlayer () {
      this.player = new window.YT.Player('player', {
        width: this.width,
        height: this.height,
        videoId: this.id,
        playerVars: {
          allowSeekAhead: 0,
        },
        events: {
          onReady: this.onPlayerReady,
          onStateChange: this.onPlayerStateChange,
        },
      });
    },
    refresh () {
      this.$events.$emit(this.$events.REWATCH_FROM_VIDEO);
      this.videoWatched = false;
      this.player.loadVideoById(this.id);
    },
    async gotoQuiz (source) {
      if (source === 'modal') {
        this.$events.$emit(this.$events.QUIZ_MODAL_BUTTON, { choice: 'Answer Quiz' });
      }
      this.$events.$emit(this.$events.OPEN_QUIZ, { openedFrom: 'video' });
      this.showModal = false;
      await this.fetchVideos({ serviceProviderId: this.serviceProviderId });
      this.$router.push({ name: 'dashboard::pro::quiz' });
    },
    success () {
      this.showSuccess = true;
    },
    skipQuiz () {
      this.showModal = false;
      this.$events.$emit(this.$events.QUIZ_MODAL_BUTTON, { choice: 'Leave' });
      this.$router.push({ name: this.to.name });
    },
    rateVideo (rating) {
      this.rated = true;
      this.$events.$emit(this.$events.VIDEO_RATING,
        {
          videoRating: rating,
          videoId: this.videoId,
          videoTitle: this.videoTitle,
        }
      );
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";
 .TITLE {
    @include margin(4 0 1 0);
    @include h3();
    font-weight: 600;
    @include mobile-only {
      @include margin(4 0 1 1);
    }
  }
  .ARROW {
    margin-top: $unit/2;
  }
  .VIDEO-WRAPPER {
    width: 100%;
  }
  .VIDEO-WRAPPER iframe {
    margin: 48px;
    position: absolute;
    top:0;
    left:0;
    width: 100vw;
    height: calc(100vw / 1.77);
  }
  .OVERLAY {
    display: flex;
    position: relative;
  }
  .CIRCLE {
    @include square(80px);
    border-radius: 50%;
    background-color: rgba(0, 0, 0, 0.65);
    align-self: center;
    display: flex;
    justify-content: center;
    margin-bottom: 4 * $unit;

    @include mobile-only {
      @include square(56px);
    }
  }
  .CONTROLS {
    display: flex;
    flex-direction: column;
    position: absolute;
    top: 45%;
    left: 0;
    right: 0;
    margin: auto;

    @include mobile-only {
      top: 25%;
    }
    .btn{
      align-self: center;
    }
  }
  .ERROR {
    color: red;
  }
  .BLUE {
    text-decoration: none;
    cursor: pointer;
    color: #286FAD;
  }
  .INFO {
    color: #1890FF;
  }
  .ICON-BUTTON {
    margin-top: -4px;
    background-color: transparent;
    border:none 0px transparent;
  }
  .MODAL {
    @include responsive(width, 100%, 400px)
  }
  </style>
